module.exports = __webpack_public_path__ + "static/media/arborea1.e1f7fc1f.webp";